import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MensajesService } from '../../service/mensajes.service';
import { ThemeService } from '../../service/theme.service';

interface PortalNavItem {
  label: string;
  link: string;
  queryParams?: { [key: string]: string };
}

@Component({
  selector: 'app-header-two',
  templateUrl: './header-two.component.html',
  styleUrls: ['./header-two.component.scss']
})
export class HeaderTwoComponent implements OnInit {
  currentUser: any = null;
  suscripcionMensajes: any;
  isOpen = false;
  isMobileMenuOpen = false;
  navItems: PortalNavItem[] = [
    { label: 'Predial', link: '/ciudadano/tramites', queryParams: { search: 'predial' } },
    { label: 'Trámites', link: '/ciudadano/tramites', queryParams: {} },
    { label: 'Reporte ciudadano', link: '/reporte' },
    { label: 'Bolsa de trabajo', link: '/ciudadano/empleos' },
    { label: 'Limpia pública', link: '/ciudadano/limpia-publica/suscribirme' }
  ];
  constructor(
    private router: Router,
    private mensajesService: MensajesService,
    public theme: ThemeService
  ) { }

  ngOnInit(): void {
    if (localStorage['currentUser']) {
      this.currentUser = JSON.parse(localStorage['currentUser']);
      const nameWords = this.currentUser.displayName.split(' ');
      let showName = '';
      nameWords.forEach((name) => {
        showName += name[0];
      });
      this.currentUser.initials = showName
    }
    this.escuchaMensajes();
  }

  private escuchaMensajes(): void {
    this.suscripcionMensajes = this.mensajesService.escucha().subscribe(  // Al llamar a escucha() le pasamos el tema que nos interesa
      msj => {
        if (msj !== 'Logout') {
          if (localStorage['currentUser']) {
            this.currentUser = JSON.parse(localStorage['currentUser']);
            const nameWords = this.currentUser.displayName.split(' ');
            this.currentUser.initials = nameWords.map((name) => {
              return name[0];
            })
          }
        } else {
          this.currentUser = null;
        }
      }
    );
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
  }

  isNavActive(item: PortalNavItem): boolean {
    const url = this.router.url;
    const path = url.split('?')[0];
    const search = this.router.parseUrl(url).queryParams['search'] || '';

    if (item.queryParams && item.queryParams.search) {
      return path === '/ciudadano/tramites' && search === item.queryParams.search;
    }
    if (item.link === '/ciudadano/tramites') {
      const onCatalog = path === '/ciudadano/tramites' || path.indexOf('/ciudadano/tramites/') === 0;
      return onCatalog && search !== 'predial';
    }
    if (item.link === '/reporte') {
      return path === '/reporte' || path === '/reporte-ciudadano';
    }
    if (item.link.indexOf('limpia-publica') !== -1) {
      return path.indexOf('limpia-publica') !== -1;
    }
    return path === item.link || path.indexOf(item.link + '/') === 0;
  }

  logout() {
    this.mensajesService.emite('Logout');
    localStorage.removeItem('currentUser');
    this.router.navigateByUrl('/ciudadano/inicio');
    this.ngOnInit();
  }

}
